import Cookies from 'js-cookie';

export const saveUtmParams = (urlParams: URLSearchParams) => {
  const utmSource = urlParams.get('utm_source');
  const utmMedium = urlParams.get('utm_medium');
  const utmCampaign = urlParams.get('utm_campaign');
  const utmTerm = urlParams.get('utm_term');
  const utmContent = urlParams.get('utm_content');

  if (utmSource) Cookies.set('utm_source', utmSource);
  if (utmMedium) Cookies.set('utm_medium', utmMedium);
  if (utmCampaign) Cookies.set('utm_campaign', utmCampaign);
  if (utmTerm) Cookies.set('utm_term', utmTerm);
  if (utmContent) Cookies.set('utm_content', utmContent);
};

export const getUtmParams = () => ({
  utmSource: Cookies.get('utm_source'),
  utmMedium: Cookies.get('utm_medium'),
  utmCampaign: Cookies.get('utm_campaign'),
  utmTerm: Cookies.get('utm_term'),
  utmContent: Cookies.get('utm_content'),
});
